import Api from './api';

class IsogdSectionsApi {
  static get = (projectSchema) => {
    const url = `gisogdSections/${projectSchema}`;
    return Api.get(url).then((response) => {
      return response.data;
    });
  };
}

export default IsogdSectionsApi;
